/**
 * Bunkering Checklist
 * Before and during fuel transfer
 * Regulatory: MARPOL, WBC3 Ch 7
 */

export const BUNKERING_CHECKLIST = {
  id: 'bunkering',
  name: 'Bunkering',
  description: 'Before and during fuel transfer',
  icon: 'Fuel',
  regulatory: 'MARPOL, WBC3 Ch 7',
  isCustomisable: true,
  items: [
    { id: 'bunk_1', text: 'Scuppers plugged', required: true },
    { id: 'bunk_2', text: 'Drip trays and spill kit in position', required: true },
    { id: 'bunk_3', text: 'Fire extinguisher at bunker station', required: true },
    { id: 'bunk_4', text: 'No smoking - signals displayed (Flag B)', required: true },
    { id: 'bunk_5', text: 'Emergency stop signal agreed with supplier', required: true },
    { id: 'bunk_6', text: 'Tank capacity confirmed - receiving tanks identified', required: true },
    { id: 'bunk_7', text: 'Continuous watch maintained throughout transfer', required: true }
  ]
};
